export default __webpack_public_path__ + "static/media/opensea-logo.df3f4d2b.png";